import { Box } from "@mui/material";

import { useEffect, useState } from "react";

import PolicyUpdateForm from "./form";
import { HRService } from "../../../../config";
import { AllPoliciesColumns, LeaveApproversColumns } from "../../../../data/Columns/hrmanagement";
import { LeaveApprovers, allPolicies } from "../../../../data/Queries/HRmanagement/leavemanagement";
import DynamicTable from "../../../../data/DynamicTable/dynamicTable";
import ApproversForm from "./form";
import DynamicTableForJson from "../../../../data/DynamicTable/dynamicTableForJson";
import LeaveTypesForm from "./form";

const base_url = HRService.uri;
const actions = {
  entity: "Leave Types",
  isSubRight: true,
  edit: {
    key: "EDIT",
    button_name: "Edit",
    Show_Button: true,
    permission: "EditPermission",
  },
  add: {
    key: "ADD",
    button_name: "Add",
    Show_Button: true,
    permission: "CreatePermission",
  },
  activateDeactivate: {
    key: "ACTIVATEDEACTIVATE",
    button_name: "Deactivate",
    Show_Button: false,
    permission: "ActivatePermission",
  },

  AssignTask: {
    key: "ASSIGN_TASK",
    button_name: "Assign Task",
    Show_Button: false,
    permission: "hasNoPermission",
    roleGroupId: [1, 2, 3, 4],
  },

  dataObject: {
    objectName: "allLeaveTypes",
    parameters: "",
  },
  showStatus: true,
};
function LeaveTypesTable() {
  return (
    <Box m="2px">
      <>
        <DynamicTableForJson
          title="Leave Types"
          subtitle="View all leave Types , add and edit"
          FormComponent={LeaveTypesForm}
          actions={actions}
          base_url={base_url}
        />
      </>
    </Box>
  );
}

export default LeaveTypesTable;
